import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-mobx-reactstrap-validation';

import { isPhoneNumber, validatePhoneNumber } from 'js/services/Regex';
import Button from 'js/components/common/Button';

import Container from './Container';
import Title from './Title';
import SubTitle from './SubTitle';
import userCountry from 'js/services/UserCountry';

@inject('page')
@observer
export default class ContactInfo extends Component {
  onSubmit = (event, formValues) => this.props.onSubmit(formValues);

  render() {
    const page = this.props.page;
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>
          <Title>Contact info</Title>
          <SubTitle>We need this to contact you in case there are any issues with your shipment.</SubTitle>

          <AvGroup>
            <AvInput
              type="text"
              name="full_name"
              placeholder="Full Name"
              autoComplete="name"
              value={page.full_name}
              required
            />
            <AvFeedback>Required.</AvFeedback>
          </AvGroup>

          <AvGroup>
            <AvInput
              name="phone_number"
              type={userCountry() === 'NG' ? 'text' : 'tel'}
              autoComplete="tel"
              placeholder="Enter your phone number"
              value={page.phone_number}
              required
              validate={validatePhoneNumber}
            />
            <AvFeedback>Please provide your phone number.</AvFeedback>
          </AvGroup>

          <Button type="submit" autoFocus>
            Save
          </Button>
        </AvForm>
      </Container>
    );
  }
}
